/** The Coaches Progress Tracking pivot, carried in the URL as ?tab=. */
export const COACHES_LEARNING_TABS = [
  "board",
  "members",
  "companies",
  "paths",
  "reviews",
] as const;

export type CoachesLearningTab = (typeof COACHES_LEARNING_TABS)[number];

export const parseCoachesTab = (value: string | null): CoachesLearningTab =>
  COACHES_LEARNING_TABS.includes(value as CoachesLearningTab)
    ? (value as CoachesLearningTab)
    : "board";

/** The one coach home. Every coaching page's back control lands here. */
export const COACHES_LEARNING_PATH = "/hub/learning-center/coaches-learning";

/** Labels the tabs share with the back controls on the detail pages. */
export const COACHES_TAB_LABELS: Record<CoachesLearningTab, string> = {
  board: "Member Board",
  members: "Members",
  companies: "Companies",
  paths: "Learning Paths",
  reviews: "Reviews",
};

/**
 * URL of one tab of Coaches Progress Tracking, with any extra query the
 * tab reads (board: enrollment, company, path, assign).
 */
export const coachesLearningUrl = (
  tab: CoachesLearningTab,
  params?: Record<string, string | number | null | undefined> | URLSearchParams,
): string => {
  const query = new URLSearchParams(
    params instanceof URLSearchParams ? params : undefined,
  );
  if (params && !(params instanceof URLSearchParams)) {
    Object.entries(params).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== "")
        query.set(key, String(value));
    });
  }
  query.set("tab", tab);
  return `${COACHES_LEARNING_PATH}?${query.toString()}`;
};
